import { Injectable } from '@angular/core';
import { IAct, IDocLink, IParameterDocumentLink } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { Observable, map, of } from 'rxjs';
import { ActsService } from 'src/app/services/acts/acts.service';
import { FileService } from 'src/app/services/file/file.service';
interface _Act extends IAct {
  _type: string;
}

type PartialAct = Partial<_Act>;

type Targets = 'both' | 'contractors' | 'subjects';

function filterDocLink(docLinks: IDocLink[], typeIds: string[]): IDocLink[] {
  if (typeIds.length == 0) return docLinks;

  if (docLinks) {
    const stack: IDocLink[] = [];

    docLinks.forEach((docLink) => {
      if (docLink.type?.ref && typeIds.includes(docLink.type.ref)) stack.push(docLink);
    });

    return stack;
  }
  return [];
}

@Injectable()
export class DocumentLinkService {
  constructor(protected fileService: FileService, private actService: ActsService) {}

  public findDocRefs(defaults: { act: IAct; parameterDocumentLink: IParameterDocumentLink }): Observable<Partial<_Act>[]> {
    const rootFG: IAct = defaults.act;

    const docTypes: string[] = defaults.parameterDocumentLink.docTypes;

    const target: Targets = defaults.parameterDocumentLink.target;

    const targets: string[] = [];

    if (target == 'both') {
      rootFG.contrators.concat(rootFG.subject).forEach((t) => targets.push(t));
    } else if (target == 'contractors') {
      rootFG.contrators.forEach((t) => targets.push(t));
    } else if (target == 'subjects') {
      rootFG.subject.forEach((t) => targets.push(t));
    } 

    const actTypeIds: string[] = defaults.parameterDocumentLink.actTypes;

    if (target.length <= 0) return of(null);

    return this.actService.getActsByIdsWithPopType(targets).pipe(
      map((acts) => {
        const stack: IAct[] = [];

        if (actTypeIds.length == 0) return acts;

        acts.map((v) => {
          if (actTypeIds.includes(v.type[0])) {
            stack.push(v);
          }
        });

        return stack;
      }),
      map((acts) => {
        const stack: PartialAct[] = [];

        acts.forEach((act) => {
          const _act: PartialAct = {
            _id: act._id,
            name: act.name,
            _type: act.type_pop[0].name || '',
            documentLinks: filterDocLink(act.documentLinks, docTypes)
          };

          stack.push(_act);
        });

        return stack;
      })
    );
  }
}
